export default __webpack_public_path__ + "static/media/Orbitron-Black.cc6a72b8.ttf";